import checkOrderStockValue from './stock';
import OrderChangeRequested from '../../../application/order/events/OrderChangeRequested';
import State from '../../../application/core/State';
import OrderValidationResult from './OrderValidationResult';
import checkOrderCheckoutValue from './checkout';
import { OrderStocks } from '../../Order';

type StockLevelValidatorType = keyof OrderStocks;

export type StockLevelValidatorConfig = { [key in StockLevelValidatorType]: Validator };
export type Validator = (state: State, event: OrderChangeRequested) => OrderValidationResult;

export const validatorsConfig: StockLevelValidatorConfig = {
    toOrderFromEstimation: checkOrderCheckoutValue,
    toOrderFromStock: checkOrderStockValue
};



// WEBPACK FOOTER //
// ./src/domain/orders/validators/config.ts